import { LoginCredentials } from "@/domain/entities";
import { z } from "zod";
export const LoginCredentialsSchema: z.ZodType<LoginCredentials> = z.object({
  email: z.email("E-mail inválido"),
  password: z.string().min(1, "Senha é obrigatória"),
});
